import React, { Component, Fragment } from "react";
import pro from "./pro.png";
import {
  Paper,
  Grid,
  Box,
  Typography,
  Avatar,
  Button,
  TextField,
  CircularProgress,
} from "@material-ui/core";
import { editUser, getUserById, uploadProfile } from "../../pages/action";
import "react-toastify/dist/ReactToastify.css";
import Radio from "@material-ui/core/Radio";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import RadioGroup from "@material-ui/core/RadioGroup";
import FormLabel from "@material-ui/core/FormLabel";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import FormHelperText from "@material-ui/core/FormHelperText";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import { get, isEmpty } from "lodash";
import { toast } from "react-toastify";
import { withStyles } from "@material-ui/core/styles";
import { useStyles } from "../../useStyles";
import { connect } from "react-redux";
import { getUser } from "../../utlis";
import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";
import Header from "./Header";

class ViewProfile extends Component {
  state = {
    imagePreviewUrl: {},
    localStore: {},
    formData: {
      fullname: "",
      username: "",
      address: "",
      gender: "",
      contactno: "",
    },
    open: false,
    id: "",
    uploadFile: false,
    file: "",
    filename: "",
  };
  handleOpen = () => {
    this.setState({ open: true });
  };

  handleClose = () => {
    this.setState({ open: false });
  };
  componentDidMount() {
    var user = getUser();
    console.log(user, "the user is");
    if (user) {
      const id = user._id;
      this.setState({ id: id });
      const resp = async () => {
        const res = await this.props.dispatch(getUserById(id));
        const data = get(res, "value.data");
        const formData = { ...this.state.formData };
        formData["username"] = data.username;
        formData["fullname"] = data.fullname;
        formData["address"] = data.address;
        formData["contactno"] = data.contactno;
        formData["gender"] = data.gender;

        this.setState({ formData });
      };
      resp();
    }
  }

  handleChange = (event) => {
    const formData = this.state.formData;
    formData[event.target.name] = event.target.value;
    console.log(formData, " form data check");
    this.setState({ formData });
  };

  newFileSelected = (event) => {
    const file = event.target.files[0];
    event.preventDefault();
    const reader = new FileReader();
    const id = event.target.id;
    reader.onloadend = () => {
      this.setState({
        [id]: file,
        uploadFile: true,
        imagePreviewUrl: reader.result,
      });
    };
    reader.readAsDataURL(file);
    setTimeout(() => this.confirmationAlert(), 200);
  };
  confirmationAlert = () => {
    confirmAlert({
      title: "Confirm to Save",
      message: "Are you sure to Upload this profile picture.",
      buttons: [
        {
          label: "Yes",
          onClick: () => this.uploadProfile(),
        },
        {
          label: "No",
          onClick: () => this.setState({ imagePreviewUrl: {} }),
        },
      ],
    });
  };
  async uploadProfile() {
    const { file } = this.state;
    console.log(file, "file checkk in func");
    const userId = getUser()._id;

    const formBody = new FormData();
    formBody.append("file", file);

    if (file) {
      const res = await this.props.dispatch(uploadProfile(userId, formBody));
      const status = res.value.status;
      console.log(status, "check");
      if (status === 200) {
        this.setState({ imagePreviewUrl: {} });
        toast.success("Profile successfully updated");
      } else {
        toast.error("Please Try Again");
      }
    }
  }

  async handleEdit(id) {
    const formData = this.state.formData;
    const res = await this.props.dispatch(editUser(id, formData));
    const status = get(res, "value.status");
    console.log(status, "status");
    if (status === 200) {
      toast.success("User successfully updated");
      this.handleClose();
    } else {
      toast.error(get(res, "response.data"));
    }
  }

  render() {
    const { classes } = this.props;
    const { imagePreviewUrl } = this.state;
    console.log(imagePreviewUrl, "check photo");
    const { user, readState } = this.props.HomePageReducer;

    return (
      <>
        <div className={classes.content}>
          {
            <>
              <Fragment>
                <label>
                  {readState === 2 && user.photo && isEmpty(imagePreviewUrl) ? (
                    <Avatar
                      className={classes.large}
                      alt="+"
                      src={user.photo}
                    />
                  ) : (
                    <Avatar
                      className={classes.large}
                      alt="+"
                      src={imagePreviewUrl}
                    />
                  )}
                  <br></br>
                  <input
                    type="file"
                    id="file"
                    style={{ display: "none" }}
                    onChange={this.newFileSelected}
                    className="form-control"
                  />
                </label>
              </Fragment>
            </>
          }
        </div>
        <Paper className={classes.paper}>
          {readState === 1 && (
            <div
              style={{
                height: "30vh",
                display: "flex",
                justifyContent: "center",
              }}
            >
              <CircularProgress />
            </div>
          )}
          {readState === 2 && (
            <>
              <Box mb={2}>
                <Typography variant="h5" align="center" color="primary">
                  {" "}
                  {get(user, "groups", "NA")}{" "}
                </Typography>
              </Box>
              <Grid container spacing={2}>
                <Grid item lg={4}>
                  FullName: {get(user, "fullname", "NA")}{" "}
                </Grid>
                <Grid item lg={4}>
                  UserName: {get(user, "username", "NA")}{" "}
                </Grid>
                <Grid item lg={4}>
                  Address:{get(user, "address", "NA")}{" "}
                </Grid>
                <Grid item lg={4}>
                  Gender:{get(user, "gender", "NA")}{" "}
                </Grid>
                <Grid item lg={4}>
                  Contact:{get(user, "contactno", "NA")}{" "}
                </Grid>
              </Grid>
              <Box mt={3} display="flex" justifyContent="flex-end">
                <Button
                  color="primary"
                  variant="contained"
                  size="small"
                  onClick={this.handleOpen}
                >
                  {" "}
                  Update Profile
                </Button>
              </Box>
            </>
          )}
        </Paper>
        <Dialog open={this.state.open} aria-labelledby="form-dialog-title">
          <DialogTitle id="form-dialog-title">Update User</DialogTitle>
          <DialogContent>
            <Grid container spacing={2}>
              <Grid item lg={6}>
                <TextField
                  autoFocus
                  margin="dense"
                  name="fullname"
                  label="Full Name"
                  value={this.state.formData.fullname}
                  fullWidth
                  variant="outlined"
                  onChange={this.handleChange}
                />
              </Grid>
              <Grid item lg={6}>
                <TextField
                  autoFocus
                  margin="dense"
                  id="name"
                  name="username"
                  label="User Name"
                  value={this.state.formData.username}
                  onChange={this.handleChange}
                  variant="outlined"
                  fullWidth
                />
              </Grid>
              <Grid item lg={6}>
                <TextField
                  autoFocus
                  margin="dense"
                  id="name"
                  name="address"
                  label="Adress"
                  value={this.state.formData.address}
                  onChange={this.handleChange}
                  variant="outlined"
                  fullWidth
                />
              </Grid>
              <Grid item lg={6}>
                <TextField
                  autoFocus
                  margin="dense"
                  id="name"
                  label="Contact"
                  name="contactno"
                  value={this.state.formData.contactno}
                  onChange={this.handleChange}
                  fullWidth
                  variant="outlined"
                />
              </Grid>
              <Grid item lg={12}>
                <FormControl component="fieldset">
                  <FormLabel component="legend">Gender</FormLabel>
                  <RadioGroup
                    row
                    name="gender"
                    onChange={this.handleChange}
                    value={this.state.formData.gender}
                  >
                    <FormControlLabel
                      value="पुरुष"
                      control={<Radio />}
                      label="पुरुष"
                    />
                    <FormControlLabel
                      value="महिला"
                      control={<Radio />}
                      label="महिला"
                    />
                    <FormControlLabel
                      value="ट्रान्सजेंडर"
                      control={<Radio />}
                      label="ट्रान्सजेंडर"
                    />
                  </RadioGroup>
                </FormControl>
              </Grid>
            </Grid>
          </DialogContent>
          <DialogActions>
            <Button
              onClick={this.handleEdit.bind(this, this.state.id)}
              color="primary"
            >
              Save
            </Button>
            <Button onClick={this.handleClose} color="primary">
              Cancel
            </Button>
          </DialogActions>
        </Dialog>
      </>
    );
  }
}
export default connect((state) => ({
  HomePageReducer: state.HomePageReducer,
}))(withStyles(useStyles)(ViewProfile));
